export const makeUsername = (name = '', email = '') => {
    const fallback = email ? email.split('@')[0] : 'producer';
    const source = name || fallback;
    const username = source
        .toLowerCase()
        .trim()
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-+|-+$/g, '');

    return username || 'producer';
};

export const buildUserProfileDocument = ({ user, name = '', username: requestedUsername = '', existing = {} } = {}) => {
    const existingProfile = existing.profile || {};
    const email = user?.email || existing.email || existingProfile.email || '';
    const normalizedRequestedUsername = makeUsername(requestedUsername, email);
    const displayName = (
        name ||
        user?.displayName ||
        existing.displayName ||
        existingProfile.name ||
        normalizedRequestedUsername ||
        (email ? email.split('@')[0] : 'Tune Producer')
    ).trim();
    const username = existing.username || existingProfile.username || normalizedRequestedUsername || makeUsername(displayName, email);
    const photoURL = user?.photoURL || existing.photoURL || existingProfile.profilePicture || '';
    const now = new Date().toISOString();

    return {
        userId: user?.uid || existing.userId || '',
        email,
        displayName,
        username,
        photoURL,
        accountType: existing.accountType || 'producer',
        onboardingComplete: existing.onboardingComplete ?? true,
        profile: {
            name: displayName,
            email,
            username,
            bio: existingProfile.bio || '',
            profilePicture: existingProfile.profilePicture || photoURL,
            genre: existingProfile.genre || '',
            location: existingProfile.location || '',
            website: existingProfile.website || '',
            socialLinks: {
                twitter: '',
                instagram: '',
                facebook: '',
                ...(existingProfile.socialLinks || {}),
            },
        },
        tracks: Array.isArray(existing.tracks) ? existing.tracks : [],
        followers: Array.isArray(existing.followers) ? existing.followers : [],
        following: Array.isArray(existing.following) ? existing.following : [],
        recentActivity: Array.isArray(existing.recentActivity) && existing.recentActivity.length
            ? existing.recentActivity
            : [`Signed up on ${new Date().toLocaleDateString()}`],
        stripeConnect: existing.stripeConnect || null,
        payoutPreferences: {
            mode: existing.payoutPreferences?.mode || 'stripe',
            manualMethod: existing.payoutPreferences?.manualMethod || '',
            payoutHandle: existing.payoutPreferences?.payoutHandle || '',
            manualPayoutEnabled: existing.payoutPreferences?.manualPayoutEnabled === true,
            updatedAt: existing.payoutPreferences?.updatedAt || null,
        },
        totalEarnings: existing.totalEarnings || 0,
        totalSales: existing.totalSales || 0,
        pendingPayout: existing.pendingPayout || 0,
        withdrawableBalance: existing.withdrawableBalance || existing.pendingPayout || 0,
        withdrawalPending: existing.withdrawalPending || 0,
        totalWithdrawn: existing.totalWithdrawn || 0,
        createdAt: existing.createdAt || now,
        updatedAt: now,
    };
};
